module.exports = __webpack_public_path__ + "static/img/ranked_mode.52695e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/word_quiz/ranked_mode.png
// module id = ifkO
// module chunks = 1